import React from "react";
// import { contextapi } from "../../helpers/contextapi";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import PageTitle from "../../components/PageTitle";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import moment from "../../helpers/moment";
import PrintAdmission from "./PrintAdmission";

const Admission = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["detailedApplications"],
    queryFn: async () => {
      const req = await axiosget("ms_applications");
      return req?.data;
    },
  });
  const _status = (data) => {
    switch (data) {
      case 0:
        return "Pending";
      case 1:
        return "Provisional Admission";
      case 2:
        return "Conditional Admission";
      default:
        return "Invalid option";
    }
  };
  return (
    <div className="row">
      <PageTitle
        title={`Application Admission Letter`}
        sub={`Please check this page regularly as your processed applications will appear on this page`}
      />
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
      {data &&
        data?.type === undefined &&
        data?.map((v, i) => (
          <div className="col-md-6 my-4" key={`_payments_for_letter_${i}`}>
            <div className="card border border-success">
              <div className="card-body">
                <p className="card-text">
                  <b>Application Reference:</b> {v?.code}
                </p>
                <p className="card-text">
                  <b>Programme: </b>
                  {v?.programme?.code} :: {v?.programme?.name}
                </p>
                <p className="card-text">
                  <b>Admission Status:</b> {_status(v?.status)}
                </p>

                <p className="card-text">
                  <b>Mode of Entry:</b> {v?.type}
                </p>
                <p className="card-text">
                  <b>Session: </b>
                  {v?.session?.code} :: {v?.session?.name}
                </p>
                <p className="card-text">
                  <b>Applied:</b> {moment(v?.createdAt)} ago
                </p>
              </div>
              <div className="card-footer text-body-secondary">
                {v?.acceptanceFee === null ? (
                  <p className="card-text p-1 text-info border border-info">
                    If the admission status is conditional or provisional, you will be required to pay acceptance fee for you to print your admission
                    letter
                  </p>
                ) : (
                  <div className="text-right">
                    <PrintAdmission v={v} />
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default Admission;
